export const isTextHebrew = text => {
  if (!text) {
    return false;
  }
  const matchAnyNonLetter = /[&/\\#,+-@!§=±()$^~%.`'"[\]:_*?<>{;}]|[0-9]/g;
  const matchHebrew = /[\u0590-\u05FF]/;
  return matchHebrew.test(text.trim().replace(matchAnyNonLetter, '')[0]);
};
//# sourceMappingURL=isTextHebrew.js.map